export default function Footer() {
  return (
    <footer className="bg-foreground-950 pt-20 pb-8 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 mb-16">
          {/* Brand + About */}
          <div>
            <a href="/" className="inline-block no-underline mb-8">
              <span className="font-sans text-background-50 text-3xl md:text-4xl font-bold whitespace-nowrap">
                yoybuy spreadsheet
              </span>
            </a>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs font-sans mb-6">
              YOYBUY Spreadsheet — ведущий табличный инструмент для заказа товаров из Китая. Помогаем покупателям со всего мира находить лучших агентов и экономить на каждом заказе.
            </p>
            <div className="flex items-center gap-4">
              {['ri-twitter-x-line', 'ri-telegram-line', 'ri-instagram-line', 'ri-youtube-line'].map((icon) => (
                <a
                  key={icon}
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors no-underline cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h4 className="font-sans text-foreground-400 text-xs uppercase tracking-widest font-semibold mb-2 whitespace-nowrap">
                Адрес
              </h4>
              <p className="text-background-50 text-sm leading-relaxed font-sans">
                Китай, Гуанчжоу
                <br />
                Торговый центр Baiyun
              </p>
            </div>
            <div>
              <h4 className="font-sans text-foreground-400 text-xs uppercase tracking-widest font-semibold mb-2 whitespace-nowrap">
                Телефон
              </h4>
              <p className="text-background-50 text-sm font-sans">
                +86 (020) 1234-5678
              </p>
            </div>
            <div>
              <h4 className="font-sans text-foreground-400 text-xs uppercase tracking-widest font-semibold mb-2 whitespace-nowrap">
                Email
              </h4>
              <a
                href="mailto:info@kaspreadsheet.com"
                className="text-background-50 text-sm font-sans hover:text-primary-400 transition-colors no-underline"
              >
                info@kaspreadsheet.com
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="flex justify-end">
            <div className="w-48 h-56 md:w-56 md:h-64 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20logistics%20and%20fulfillment%20workspace%20with%20cardboard%20boxes%20neatly%20stacked%20on%20warm%20beige%20surface%2C%20organized%20packaging%20supplies%20in%20background%2C%20soft%20natural%20window%20light%2C%20Scandinavian%20editorial%20style%2C%20professional%20ecommerce%20fulfillment%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%2C%20elegant%20simple%20composition&width=500&height=600&seq=yoybuy-footer-v2-img&orientation=portrait"
                alt="Логистика YOYBUY"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs font-sans">
            &copy; {new Date().getFullYear()} YOYBUY Spreadsheet. Все права защищены.
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-foreground-500 hover:text-background-50 text-xs font-sans no-underline transition-colors whitespace-nowrap">
              Главная
            </a>
            <a href="/shopping-guide" className="text-foreground-500 hover:text-background-50 text-xs font-sans no-underline transition-colors whitespace-nowrap">
              Руководство
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 hover:text-background-50 text-xs font-sans no-underline transition-colors whitespace-nowrap"
            >
              Контакты
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}